@let isVacant = isVacantSg();
@let isSaving =
  recordsEc.plugins.editingPlugin.feature.selectors.isSubmitting.asSignal() ||
  functionalUsagePlugin.selectors.isLoading.asSignal();

@if (recordSg()) {
  <atn-ds-centered-overlay type="wide">
    <div class="atn-space-room-data-modal">
      <atn-ds-widget title="Update Room Data">
        <div actions>
          <i
            class="atn-icon atn-close atn-red"
            (click)="cancelClickHandler()"
          ></i>
        </div>

        <div class="atn-space-room-data-modal__content">
          <!-- Room Type -->
          <atn-ds-select-single
            label="Room Type"
            [config]="{
              overlay: {
                entityName: 'Room Type',
                hasSearch: true,
              },
            }"
            [required]="true"
            [items]="roomTypesItemsSg()"
            [value]="roomTypeIdSg()"
            (valueChange)="updateRecord('roomTypeId', $event)"
          />

          <!-- Description -->
          <atn-ds-text-area
            label="Description"
            placeholder="Enter a description"
            [value]="descriptionSg()"
            (valueChange)="updateRecord('description', $event)"
            [styleOverrides]="{
              height: '100px',
              resize: 'vertical',
            }"
          ></atn-ds-text-area>

          <!-- Comment -->
          <atn-ds-text-area
            label="Comment"
            placeholder="Enter a comment"
            [value]="commentSg()"
            (valueChange)="updateRecord('comment', $event)"
            [styleOverrides]="{
              height: '100px',
              resize: 'vertical',
            }"
          ></atn-ds-text-area>

          <!-- Is Vacant -->
          <div class="atn-space-room-data-modal__row">
            <atn-ds-checkbox
              label="Is Vacant"
              [selected]="isVacant"
              (selectedChange)="isVacantCheckboxChangedHandler($event)"
            ></atn-ds-checkbox>
          </div>

          <!-- Anomalies section -->
          <div class="atn-space-room-data-modal__anomalies">
            <span class="atn-space-room-data-modal__label"
              ><b>Anomalies</b></span
            >

            @for (anomaly of anomalyItemsSg(); track anomaly.value) {
              <div class="atn-space-room-data-modal__row">
                <atn-ds-checkbox
                  [selected]="anomaliesSg().includes(anomaly.value)"
                  (selectedChange)="
                    anomalyCheckboxChangedHandler(anomaly.value)
                  "
                  [label]="anomaly.label"
                ></atn-ds-checkbox>
              </div>
            }
          </div>

          <!-- Notice for Description/Room Type change impact -->
          @if (showScenariosImpactNoticeSg()) {
            <div class="atn-space-room-data-modal__notice">
              <atn-ds-notice
                [style]="StyleEnum.Warning"
                description="Modifying the Description or Room Type will impact this room across all scenarios."
              />
            </div>
          }
        </div>

        <div
          class="atn-space-room-data-modal__footer"
          footer
        >
          <atn-ds-button
            type="transparent"
            (click)="cancelClickHandler()"
            >Cancel</atn-ds-button
          >
          <atn-ds-button
            (click)="saveClickHandler()"
            [loading]="isSaving"
            >Save</atn-ds-button
          >
        </div>
      </atn-ds-widget>
    </div>
  </atn-ds-centered-overlay>
}
